
<div class="row">
  <div class="col-sm-12 col-lg-12 col-md-12 padding-0">
    <app-ca-prop></app-ca-prop>
    <!--collapsible panel bar goes here-->
    <kendo-panelbar #panelbar
                    [animate]="true"
                    (stateChange)="onPanelStateChange($event)">
      <kendo-panelbar-item [expanded]="true">
        <!--[selected]="expandedItem === shipptingLbl"
        [expanded]="expandedItem === shipptingLbl"
        >-->
        <ng-template kendoPanelBarItemTitle>
          <span>{{lblText.shippingLbl?lblText.shippingLbl:checkOut.shippingLbl}}</span>
          <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                *ngIf="!checkOutState.isShippingFormValid && checkOutState.isShippingFormSubmitted"></span>
          <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                *ngIf="checkOutState.isShippingFormValid && checkOutState.isShippingFormSubmitted"
                style="color:green;font-weight:600"></span>
        </ng-template>
        <ng-template kendoPanelBarContent>
          <div class="row">

            <div class="col-12">
              <div class="row currentAddress">
                <div class="col-sm-12 col-md-6 currentAddress1">
                  <h6>{{lblText.currentBillingAddressLbl?lblText.currentBillingAddressLbl:checkOut.currentBillingAddressLbl}}</h6>
                  {{currentBilling?.customerNumber}}-{{currentBilling?.customerName}}<br />
                  {{currentBilling?.addressLine1}}{{currentBilling?.addressLine2}}<br />
                  {{currentBilling?.city}},{{currentBilling?.state}} {{currentBilling?.zipCode}}
                </div>
                <div class="col-sm-12 col-md-6 currentAddress2">
                  <h6>
                    {{lblText.currentShippingAddressLbl?lblText.currentShippingAddressLbl:checkOut.currentShippingAddressLbl}}
                    <span *ngIf="isMobileOrTab" class="changeShippingAddr" (click)="showHideShippingAddress()">
                      Change
                    </span>
                  </h6>
                  {{currentShipping?.customerNumber}}-{{currentShipping?.customerName}}<br />
                  {{currentShipping?.addressLine1}}{{currentShipping?.addressLine2}}<br />
                  {{currentShipping?.city}},{{currentShipping?.state}} {{currentShipping?.zipCode}}
                </div>
              </div>
              <div class="col-12  padding-0">
                <app-customer-address [hideShippingAddrGrid]="hideShippingAddrGrid" (hideShippingAddr)="showHideShippingAddress()">
                </app-customer-address>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 center">

              <button kendoButton primary="true" class="m-3" (click)="continueToOrderDetails()">
                {{lblText.continueLbl?lblText.continueLbl:checkOut.continueLbl}}
              </button>
            </div>
          </div>

        </ng-template>
      </kendo-panelbar-item>
      <kendo-panelbar-item [expanded]="false">
        <ng-template kendoPanelBarItemTitle>
          <span>{{lblText.orderDetailsLbl?lblText.orderDetailsLbl:checkOut.orderDetailsLbl}}</span>
          <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                *ngIf="!checkOutState.isODFormValid && checkOutState.isODFormSubmitted"></span>
          <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                *ngIf="checkOutState.isODFormValid && checkOutState.isODFormSubmitted"
                style="color:green;font-weight:600"></span>
        </ng-template>
        <ng-template kendoPanelBarContent>
          <div class="row">
            <!--<div class="col-1"></div>-->
            <div class="col-12 padding-10">
              <app-orderdetails #orderDetailsCheck
                                [orderDetailsIn]="orderDetailsValues"
                                (orderDetailsOut)="setOrderDetailsValue($event)">

              </app-orderdetails>
            </div>
            <!--<div class="col-1"></div>-->
          </div>
          <div class="row">
            <div class="col-12 center">
              <button kendoButton class="m-3" primary="true" (click)="continueToReviewOrder()">
                {{lblText.continueLbl?lblText.continueLbl:checkOut.continueLbl}}
                <!--<kendo-loader>
                </kendo-loader>-->
                <!-- class="k-i-loading" -->
              </button>
            </div>
          </div>
        </ng-template>
      </kendo-panelbar-item>
      <kendo-panelbar-item [expanded]="false">
        <ng-template kendoPanelBarItemTitle>
          <span>{{lblText.reviewOrderLbl?lblText.reviewOrderLbl:checkOut.reviewOrderLbl}}</span>
          <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                *ngIf="!checkOutState.isRCFormValid && checkOutState.isRCFormSubmitted"></span>
          <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                *ngIf="checkOutState.isRCFormValid && checkOutState.isRCFormSubmitted"
                style="color:green;font-weight:600"></span>
        </ng-template>
        <ng-template kendoPanelBarContent>
          <div class="row">
            <div class="col-12">
              <app-cart-review></app-cart-review>
            </div>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>
  </div>
  <div class="col-12">
    <div class="d-flex justify-content-center align-items-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
      <div *ngIf="hasPlaceOrderAccess && !freightEstimateFlag">
          <button kendoButton [icon]="'shopping-cart'"
                  (click)="placeOrder()" [disabled]="orderInProcess || this.checkoutService.freightCalcInProgress" class="m-3" primary="true">
            {{lblText.confirmOrderLbl?lblText.confirmOrderLbl:checkOut.confirmOrderLbl}}
            <kendo-loader *ngIf="orderInProcess" style="color:blue"></kendo-loader>
          </button>
        </div>
      <div *ngIf="hasPlaceOrderAccess && freightEstimateFlag">
        <div *ngIf="!checkOutCCCustomer && !checkOutCConlyCustomer">
          <button kendoButton [icon]="'shopping-cart'"
                  (click)="placeOrderWithChargeToAccount()" [disabled]="orderInProcess  || this.checkoutService.freightCalcInProgress" class="m-3" primary="true">
            {{ lblText.confirmOrderLbl?lblText.confirmOrderLbl:checkOut.confirmOrderLbl }}
            <kendo-loader *ngIf="orderInProcess" style="color:blue"></kendo-loader>
          </button>
        </div>
        <div *ngIf="checkOutCCCustomer || checkOutCConlyCustomer">
          <button kendoButton [icon]="'shopping-cart'" *ngIf="checkOutCCCustomer"
                  (click)="placeOrderWithChargeToAccount()" [disabled]="orderInProcess || orderInProcessCC  || this.checkoutService.freightCalcInProgress" class="m-3" primary="true">
            {{ lblText.confirmOrderCCLbl?lblText.confirmOrderCCLbl:checkOut.confirmOrderCCLbl }}
            <kendo-loader *ngIf="orderInProcess" style="color:blue"></kendo-loader>
          </button>
          &nbsp;&nbsp;&nbsp;
          <button kendoButton [icon]="'shopping-cart'" *ngIf="(checkOutCCCustomer || checkOutCConlyCustomer)"
                  (click)="openPaymentWithCCDialog()" [disabled]="orderInProcess  || orderInProcessCC  || this.checkoutService.freightCalcInProgress" class="m-3" primary="true">
            {{lblText.confirmOrderCCOnlyLbl?lblText.confirmOrderCCOnlyLbl:checkOut.confirmOrderCCOnlyLbl}}
            <kendo-loader *ngIf="orderInProcessCC" style="color:blue"></kendo-loader>
          </button>
        </div>
       </div>
      </div>
  </div>

  <section>
    <kendo-dialog *ngIf="orderAcknowledgementDialog.opened">
      <div style="text-align: center; margin: 30px;" *ngIf="!orderAcknowledgementDialog.isError">
        <span class="k-icon k-i-check-outline k-i-checkmark-outline k-i-success"
              style="font-size:50px;color:green"></span>
        <p>{{lblText.submitedInfo1?lblText.submitedInfo1:checkOut.submitedInfo1}}</p>
        <h4>{{lblText.submitedInfo2?lblText.submitedInfo2:checkOut.submitedInfo2}}</h4>
        <p>
          {{lblText.kawneerOrderLbl?lblText.kawneerOrderLbl:checkOut.kawneerOrderLbl}}:  #{{lblText.kdLbl?lblText.kdLbl:checkOut.kdLbl}}{{orderAcknowledgementDialog?.acknowledgeNumber}}.
        </p>

        <p>
          <button kendoButton primary="true" style="width: 300px;" [routerLink]="['/home']">{{lblText.continueShoppingLbl?lblText.continueShoppingLbl:checkOut.continueShoppingLbl}}</button>
        </p>
        <div>
          <a style=" cursor:pointer;" [routerLink]="['/survey']">
            {{lblText.surveyFeedbackLbl?lblText.surveyFeedbackLbl:checkOut.surveyFeedbackLbl}}

          </a>
        </div>
        <!--<p>
          <button kendoButton primary="true" style="width: 300px;" [routerLink]="['/survey']">{{lblText.surveyLbl?lblText.surveyLbl:checkOut.surveyLbl}}</button>
        </p>-->
      </div>
      <div style="text-align: center; margin: 30px;" *ngIf="orderAcknowledgementDialog.isError">
        <span class="k-icon k-i-close-outline k-i-x-outline k-i-error"
              style="font-size:50px;color:red"></span>
        <h4>{{lblText.submitedInfo3?lblText.submitedInfo3:checkOut.submitedInfo3}}</h4>
        <p>{{lblText.submitedInfo4?lblText.submitedInfo4:checkOut.submitedInfo4}}</p>
        <p>
          <button kendoButton primary="true" style="width: 300px;" (click)="closeConfirmDialog()">{{lblText.closeLbl?lblText.closeLbl:checkOut.closeLbl}}</button>
        </p>
      </div>
    </kendo-dialog>
  </section>

  <!-- This is for snappay test section start-->
  <section class="dialogsection">
    <kendo-dialog title="Payment"
                  [width]="'80%'"
                  [height]="'90%'"
                  *ngIf="showPaymentDialog" (close)="cancelOrder()">
      <div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row"
           style="text-align: center"
           *ngIf="paymentPortalInitializing">
        Please wait we are initializing.....
      </div>
      <iframe [src]="url" height="88%" width="100%"></iframe>
      <div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row"
           style="text-align: center">
        <button kendoButton
                (click)="cancelOrder()"
                class="m-3 clearKendoButton btn btn-success" style="margin: 0 auto;">
          Cancel
        </button>
      </div>
    </kendo-dialog>
  </section>
  <!-- This is for snappay test section end-->
  <!-- This is for credit card kendo-dialog section start-->
  <section class="dialogsection">
    <kendo-dialog *ngIf="cCPaymentConfirmationDialog" (close)="ClosePaymentWithCCDialog()">
      <div><p style="text-align: center;"><u><b>You have chosen to Pay by Credit Card</b></u></p></div>
      <div *ngIf="this.checkoutService.checkOutProcessModel.orderDetail.freightTerms.value == 1 && !this.checkoutService.prepaidFreightSelected">
        <div><p style="text-align: center;color: red;"><b>Paying by Credit Card requires Freight Charges to be included.</b></p></div>
        <div><p style="text-align: center;color: red;"><b>Cancel and Return to Payment Options and calculate freight.</b></p></div>
      </div>
      <div *ngIf="this.checkoutService.checkOutProcessModel.orderDetail.freightTerms.value == 2">
        <div><p style="text-align: center;">By proceeding, you acknowledge and agree to a 3% credit card surcharge based on the Order Total.</p></div>
        <div><p style="text-align: center;">The estimated surcharge for this order is {{this.creditCardCharge| currency}}</p></div>
        <div><p style="text-align: center;"><b>Your Estimated Order Total including surcharge is {{this.creditCardTotalAmount| currency}}</b></p></div>
        <div><p style="text-align: center;color:red;"><b>Note: Shipping costs may still be applicable for pickup orders depanding upon the products orginating location. If applicable, you will be notified of additional charges during Order Processing</b></p></div>
        <div><p style="text-align: center;">Your credit card will be authorized on the next screen and charged when material ships.</p></div>
      </div>
      <div *ngIf="(this.checkoutService.checkOutProcessModel.orderDetail.freightTerms.value == 1 && this.checkoutService.prepaidFreightSelected) ||  this.checkoutService.checkOutProcessModel.orderDetail.freightTerms.value == 3 ||  this.checkoutService.checkOutProcessModel.orderDetail.freightTerms.value == 4">
        <div><p style="text-align: center;">By proceeding, you acknowledge and agree to a 3% credit card surcharge based on the Order Total.</p></div>
        <div><p style="text-align: center;">The estimated surcharge for this order is {{this.creditCardCharge| currency}}</p></div>
        <div><p style="text-align: center;"><b>Your Estimated Order Total including surcharge is {{this.creditCardTotalAmount| currency}}</b></p></div>
        <div><p style="text-align: center;">Your credit card will be authorized on the next screen and charged when material ships.</p></div>
      </div>
      <div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row"
           style="text-align: center">
        <button kendoButton
                (click)="proceedToMakePaymentWithCCAndPlaceOrder()"
                class="m-3 clearKendoButton btn btn-success" style="margin: 0 auto;" *ngIf="this.checkoutService.checkOutProcessModel.orderDetail.freightTerms.value > 1 ||  (this.checkoutService.checkOutProcessModel.orderDetail.freightTerms.value == 1 && this.checkoutService.prepaidFreightSelected)">
          Accept Fee and Continue
        </button>
        <button kendoButton
                (click)="ClosePaymentWithCCDialog()"
                class="m-3 clearKendoButton btn btn-success" style="margin: 0 auto;">
          Cancel and Return to Payment Options
        </button>
      </div>
    </kendo-dialog>
  </section>
  <!-- This is for credit card kendo-dialog section start-->
